export default __webpack_public_path__ + "static/media/annex2.4a1e03c5.png";